/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Editor_Import_Subtitles_Failed_ToastInputs */

const en_editor_import_subtitles_failed_toast = /** @type {(inputs: Editor_Import_Subtitles_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importing subtitle events failed: ${i?.message}`)
};

const fr_editor_import_subtitles_failed_toast = /** @type {(inputs: Editor_Import_Subtitles_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Echec de l'importation des evenements de sous-titres : ${i?.message}`)
};

const de_editor_import_subtitles_failed_toast = /** @type {(inputs: Editor_Import_Subtitles_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importieren von Untertitelereignissen fehlgeschlagen: ${i?.message}`)
};

const it_editor_import_subtitles_failed_toast = /** @type {(inputs: Editor_Import_Subtitles_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importazione degli eventi dei sottotitoli non riuscita: ${i?.message}`)
};

const ru_editor_import_subtitles_failed_toast = /** @type {(inputs: Editor_Import_Subtitles_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось импортировать события субтитров: ${i?.message}`)
};

const es_editor_import_subtitles_failed_toast = /** @type {(inputs: Editor_Import_Subtitles_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al importar eventos de subtítulos: ${i?.message}`)
};

const zh_cn2_editor_import_subtitles_failed_toast = /** @type {(inputs: Editor_Import_Subtitles_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`导入字幕事件失败：${i?.message}`)
};

const ja_editor_import_subtitles_failed_toast = /** @type {(inputs: Editor_Import_Subtitles_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`字幕イベントのインポートに失敗しました: ${i?.message}`)
};

const hi_editor_import_subtitles_failed_toast = /** @type {(inputs: Editor_Import_Subtitles_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`उपशीर्षक इवेंट आयात करने में विफलता: ${i?.message}`)
};

const pt_pt2_editor_import_subtitles_failed_toast = /** @type {(inputs: Editor_Import_Subtitles_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A importação de eventos de legenda falhou: ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Importing subtitle events failed: {message}" |
*
* @param {Editor_Import_Subtitles_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_import_subtitles_failed_toast = /** @type {((inputs: Editor_Import_Subtitles_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Import_Subtitles_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor_import_subtitles_failed_toast(inputs)
	if (locale === "de") return de_editor_import_subtitles_failed_toast(inputs)
	if (locale === "it") return it_editor_import_subtitles_failed_toast(inputs)
	if (locale === "ru") return ru_editor_import_subtitles_failed_toast(inputs)
	if (locale === "es") return es_editor_import_subtitles_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_editor_import_subtitles_failed_toast(inputs)
	if (locale === "ja") return ja_editor_import_subtitles_failed_toast(inputs)
	if (locale === "hi") return hi_editor_import_subtitles_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_editor_import_subtitles_failed_toast(inputs)
	return en_editor_import_subtitles_failed_toast(inputs)
});